<template>
    <div class="wrapper col">
        <h1>Contact Us!</h1>
        <h2><a href="mailto:info@monroe.live">info@monroe.live</a></h2>
    </div>
</template>

<script>
export default {
    name: 'Contact',
}
</script>

<style lang="scss" scoped>
@import '../interface.scss';
</style>